import { render, staticRenderFns } from "./viewUserGroup.vue?vue&type=template&id=219d10f8&"
import script from "./viewUserGroup.vue?vue&type=script&lang=js&"
export * from "./viewUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./viewUserGroup.vue?vue&type=style&index=0&id=219d10f8&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports